import {
    FETCH_USER_LIST_STARTED,
    FETCH_USER_LIST_SUCCESS,
    FETCH_USER_LIST_FAILURE
} from '../actions/actionTypes';

const initialState = {
    isLoading: false,
    users: [],
    error: null
};

export default function userListReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_USER_LIST_STARTED:
            return {
                ...state,
                isLoading: true
            };
        case FETCH_USER_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                users: action.payload
            };
        case FETCH_USER_LIST_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            };
        default:
            return { ...state };
    }
}



// WEBPACK FOOTER //
// ./src/reducers/userList.js